export default __webpack_public_path__ + "static/media/gn.7133ed60.svg";